import React, {createContext, StrictMode} from 'react';
import { createRoot } from 'react-dom/client'; 
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import UserStore from "./store/UserStore";
import ProductStore from "./store/ProductStore";
import ScrollControl from './ScrollControl';

export const Context = createContext(null);

const root = createRoot(document.getElementById('root')); 

if (process.env.NODE_ENV !== 'development') {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
}

root.render(
    <StrictMode>
        <Context.Provider value={{
            user: new UserStore(),
            product: new ProductStore(),
        }}>
            <BrowserRouter>
                <ScrollControl />
                <App />
            </BrowserRouter>
        </Context.Provider>
    </StrictMode>
);